import { LONG_BDAY_FORMAT } from "../../../ana-toolbox/ana-toolbox.js";
import { pipe } from "../../../../../utils/pipe.js";
import { parse, isValid, isBefore, differenceInYears } from "date-fns/fp";
import { parsePhoneNumberFromString } from "libphonenumber-js/max";
import { parsePhoneNumberFromString as parsePhoneNumberFromString$1 } from "libphonenumber-js/mobile";
import { isInBetween, isLessOrEq } from "../helpers/predicates.js";
import { emailValidationHelpers } from "./emailValidation.js";
import "../../../../../constants/date/date.js";
import "../../../../../type/Appointment.js";
import "date-fns/fp/format";
import "date-fns/isValid";
import "date-fns/parse";
const defaultBirthdayErrorMessages = {
  invalidDate: "Please insert a valid date. For example 31.12.1990.",
  inPast: "Please insert a date in the past.",
  empty: "This field is required.",
  adult: "Please enter a valid date. The insurance holder’s age must be above 18 years.",
  maxAge: "Please choose an age between 1 and 120 years"
};
const MAXIMUM_AGE = 120;
const TEEN_AGE = 18;
function dateValidation(message) {
  return this.test("birthday", "", function(value) {
    const { path, createError } = this;
    if (!value)
      return createError({
        path,
        message: (message == null ? void 0 : message.empty) || defaultBirthdayErrorMessages.empty
      });
    const trimmedValue = value.trim();
    const isISOFormat = /^\d{4}-\d{2}-\d{2}$/.test(trimmedValue);
    if (!isISOFormat && trimmedValue.length !== LONG_BDAY_FORMAT.length)
      return createError({
        path,
        message: (message == null ? void 0 : message.invalidDate) || defaultBirthdayErrorMessages.invalidDate
      });
    const date = isISOFormat ? new Date(trimmedValue) : parse(/* @__PURE__ */ new Date())(LONG_BDAY_FORMAT)(value);
    const now = /* @__PURE__ */ new Date();
    const isDateValid = isValid(date);
    const isPast = isBefore(now)(date);
    if (!isDateValid)
      return createError({
        path,
        message: (message == null ? void 0 : message.invalidDate) || defaultBirthdayErrorMessages.invalidDate
      });
    if (!isPast)
      return createError({
        path,
        message: (message == null ? void 0 : message.inPast) || defaultBirthdayErrorMessages.inPast
      });
    return isDateValid;
  });
}
function adultValid(message) {
  return this.test("adult", "", function(value) {
    const { path, createError } = this;
    if (!value)
      return createError({
        path,
        message: defaultBirthdayErrorMessages.empty
      });
    const trimmedValue = value.trim();
    const isISOFormat = /^\d{4}-\d{2}-\d{2}$/.test(trimmedValue);
    const date = isISOFormat ? new Date(trimmedValue) : parse(/* @__PURE__ */ new Date())(LONG_BDAY_FORMAT)(value);
    const now = /* @__PURE__ */ new Date();
    const isAdult = pipe(differenceInYears(date), isInBetween(TEEN_AGE, MAXIMUM_AGE))(now);
    if (!isAdult)
      return createError({
        path,
        message: message || defaultBirthdayErrorMessages.adult
      });
    return isAdult;
  });
}
function maxAgeValid(message) {
  return this.test("maxAge", "", function(value) {
    const { path, createError } = this;
    if (!value)
      return createError({
        path,
        message: defaultBirthdayErrorMessages.empty
      });
    const date = parse(/* @__PURE__ */ new Date())(LONG_BDAY_FORMAT)(value);
    const now = /* @__PURE__ */ new Date();
    const isLessThanMaximumAge = pipe(differenceInYears(date), isLessOrEq(MAXIMUM_AGE))(now);
    if (!isLessThanMaximumAge)
      return createError({
        path,
        message: message || defaultBirthdayErrorMessages.maxAge
      });
    return isLessThanMaximumAge;
  });
}
function addressValidation(message) {
  return this.test("address", "", function(value) {
    const { path, createError } = this;
    const haveCorrectSize = value ? value.length > 3 : false;
    const haveNumber = value ? / [0-9]{1,}/.test(value) : false;
    const valid = haveCorrectSize && haveNumber;
    if (!valid)
      return createError({
        path,
        message: message || "Please enter a valid address (at least 3 characters, 1 space and a number)"
      });
    return true;
  });
}
function emailValidation(message) {
  return this.test("customEmail", "", function(value) {
    const { path, createError } = this;
    if (!value)
      return true;
    const valid = emailValidationHelpers.isValid(value || "");
    if (valid) {
      return true;
    }
    return createError({ path, message });
  });
}
function phoneValidation(message) {
  return this.test("phoneNumber", "", function(value) {
    var _a;
    const { path, createError } = this;
    if (!value || typeof value !== "string")
      return true;
    try {
      const valid = (_a = parsePhoneNumberFromString(value)) == null ? void 0 : _a.isValid();
      if (valid)
        return valid;
    } catch (_) {
    }
    return createError({ path, message });
  });
}
function mobilePhoneValidation(message) {
  return this.test("mobilePhoneNumber", "", function(value) {
    var _a;
    const { path, createError } = this;
    if (!value || typeof value !== "string")
      return true;
    try {
      const valid = (_a = parsePhoneNumberFromString$1(value)) == null ? void 0 : _a.isValid();
      if (valid)
        return valid;
    } catch (_) {
    }
    return createError({ path, message });
  });
}
export {
  addressValidation,
  adultValid,
  dateValidation,
  emailValidation,
  maxAgeValid,
  mobilePhoneValidation,
  phoneValidation
};
